import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { QueryParametersUpdate } from '@common/models/queryParametersUpdate.model';
import { Field } from '@common/models/field.model';
import { AreaUpdate } from '@common/models/areaUpdate.model';
import { AreaSummary } from '@common/models/areaSummary.model';
import { Client } from '@common/models/client.model';

@Component({
  selector: 'app-sortable-table-component',
  templateUrl: './sortableTable.component.html',
  styleUrls: ['./sortableTable.component.scss'],
  animations: [
    trigger('spinnerVisibility', [
      state('visible', style({
        opacity: 1,
        visibility: 'visible',
      })),
      state('invisible',   style({
        opacity: 0,
        visibility: 'hidden',
      })),
      transition('visible <=> invisible', animate('200ms ease-in')),
    ]),
  ],
})
export class SortableTableComponent {
  @Input() id: string;
  @Input() fields: Field[];
  @Input() items: AreaUpdate[] | AreaSummary[] | Client[];
  @Input() itemsPerPage: number;
  @Input() showSearch: boolean;
  @Input() showDetails: boolean;
  @Input() showAccept: boolean;
  @Input() showEdit: boolean;
  @Input() showDelete: boolean;
  @Input() params: string[] = [];
  @Input() generateSpecificParams;
  @Input() prefixes;
  @Input() keyNames;
  @Input() postfixes;
  @Input() addButtonLink;
  @Input() addButtonText;
  @Input() fn;
  @Input() deleteItem;
  @Input() totalItems: number;
  @Input() queryParameters;
  @Output() onKeyDown: EventEmitter<any> = new EventEmitter();
  @Output() parametersUpdated: EventEmitter<QueryParametersUpdate> = new EventEmitter();
  spinnerVisibilityState = 'invisible';

  generateLink(item): string {
    let link = '';
    this.prefixes.forEach(prefix => link += prefix + '/');
    this.keyNames.forEach(keyName => link += item[keyName] + '/');
    if (this.postfixes) {
      this.postfixes.forEach(postfix => link += postfix + '/');
    }
    return link;
  }

  generateParams(item) {
    if (this.generateSpecificParams) {
      return this.generateSpecificParams(item);
    }

    const paramsToSet = {};

    this.params.forEach((param) => {
      paramsToSet[param] = item[param];
    });

    return paramsToSet;
  }

  keyUp($event: KeyboardEvent): void {
    const target = <HTMLInputElement>$event.target;
    const inputValue = target.value;

    if (this.queryParameters.query !== inputValue) {
      this.showSpinner();
      this.parametersUpdated.emit({
        query: inputValue,
        page: 1,
      });
    }
  }

  changePage(page: number): void {
    this.showSpinner();
    this.parametersUpdated.emit({ page });
  }

  sort(field: string): void | false {
    const currentField = this.fields.filter((fieldFromArray) => {
      if (fieldFromArray.shortName === field) {
        return true;
      }
    })[0];

    if (!currentField.sortable) {
      return false;
    }

    this.showSpinner();

    if (this.queryParameters.orderBy === field) {
      const newSortOrder = (this.queryParameters.sortOrder === 'ASC') ? 'DESC' : 'ASC';
      this.parametersUpdated.emit({ sortOrder: newSortOrder });
    } else {
      this.parametersUpdated.emit({
        orderBy: field,
        sortOrder: 'ASC',
      });
    }
  }

  showSpinner(): void {
    this.spinnerVisibilityState = 'visible';
  }

  hideSpinner(): void {
    this.spinnerVisibilityState = 'invisible';
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/SortableTableComponent/sortableTable.component.ts